import { useCallback, useMemo, useState } from "react";
import { useToast } from "../../../Hooks/ToasContext";
import { ISellerEntity } from "../../../Services/api/sellers/sellers.interface";
import { ListSellersUseCase } from "../../../Usecase/Sellers/list-sellers-usecase";
import { IListSearchPayload } from "../../../Components/List/list.types";

interface IuseListSellersProps {
    listSellersUseCase: ListSellersUseCase
}

export function useListSellers({ listSellersUseCase }: IuseListSellersProps){
    const [loading, setLoading] = useState(true)
    const [loadError, setLoadError] = useState(false)
    const [data, setData] = useState<ISellerEntity[]>([])
    const [totalRegisters, setTotalRegisters] = useState(0)
    const [sellerToResetPassword, setSellerToResetPassword] = useState<ISellerEntity | null>(null)
    const [currentSearch, setCurrentSearch] = useState('')
    const { showToast } =  useToast()

    const listSellers = useCallback(async ({ page: currentPage, search = '' }: { page : number; search?: string }) => {
        try {
          setLoading(true)
          setLoadError(false)
          
          const listResult = await listSellersUseCase.handle({ page: currentPage, searchBy: search });

          if (listResult.isFailure) {
            setLoadError(true)
            showToast(String(listResult?.error?.error), 'error');
            return;
          }

         const list = listResult.getValue()

         if(list){
            setData(list.data)
            setTotalRegisters(list.total)
            setLoadError(false)
         }

         setCurrentSearch(search)
        } catch (error) {
          setLoadError(true)
          console.error("error useListSellers function: ", error)
        } finally {
          setLoading(false);
        }
      }, [listSellersUseCase, showToast]);

    const handleSearch = useCallback(({ page, searchBy }: IListSearchPayload) => {
      listSellers({ page, search: searchBy })
    }, [listSellers]);

    const handlePageChange = useCallback(({ page, searchBy }: IListSearchPayload) => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      listSellers({ page, search: searchBy ?? currentSearch })
    }, [listSellers, currentSearch]);

    const list = useMemo(() => {
        return data?.map(seller => ({ ...seller })) || []
    }, [data])

    return {
        loading,
        loadError,
        listSellers,
        list,
        data,
        sellerToResetPassword,
        setSellerToResetPassword,
        totalRegisters,
        handleSearch,
        handlePageChange,
        currentSearch,
    }
}
